import { useCallback } from "react";

import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import companyToken from "Utils/companyToken";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";
import { partnerType } from "Utils/isPartner";

import useAsync from "Common/useAsync";

export const fetchSiteConfig = (dispatch) => {
  const companyIDToken = companyToken();
  const data = {
    partner: partnerType(),
    ...(companyIDToken
      ? {
          company_id_token: companyIDToken,
        }
      : {}),
  };
  const params = new URLSearchParams(data).toString();
  return fetchWithCSRFToken(`/site-config?${params}`, {
    method: "GET",
  })
    .then((response) => response.json())
    .then((siteConfig) => {
      dispatch(
        siteConfigSlice.actions.configLoaded({
          siteConfig,
        }),
      );
      return siteConfig;
    });
};
export const useSiteConfig = () => {
  const dispatch = useDispatch();
  const asyncFunction = useCallback(() => fetchSiteConfig(dispatch), []);
  const result = useAsync(asyncFunction);
  return result;
};
export const siteConfigSlice = createSlice({
  name: "siteConfig",
  initialState: null,
  reducers: {
    configLoaded(_state, action) {
      return action.payload.siteConfig;
    },
  },
});
